import React from 'react';
import { RegularButton } from 'fronton-react';
import { cx } from 'linaria';
import { AkinatorCompletion } from 'types/suggestions';
import { akinatorCompletionButton, akinatorCompletionButtonText } from './styles';
import { sendAkinatorCompletionAnalyticsEvent } from './hooks/use-akinator-analytics-event';
import { getSuggestionOptionAriaProps } from '../utils/search-suggestions-aria';

type CompletionsAkinatorButtonProps = {
  completion: AkinatorCompletion;
  elementIndex: number;
  navigationIndex: number;
  onMouseEnter: (idx: number) => void;
  onMouseLeave: () => void;
  onCompletionClick: (completion: AkinatorCompletion) => void;
};

export const CompletionsAkinatorButton: React.FC<CompletionsAkinatorButtonProps> = ({
  completion,
  elementIndex,
  navigationIndex,
  onMouseEnter,
  onMouseLeave,
  onCompletionClick,
}) => {
  const isSelected = elementIndex === navigationIndex;
  const optionAriaProps = getSuggestionOptionAriaProps(elementIndex, navigationIndex);

  return (
    <RegularButton
      {...optionAriaProps}
      variant="outline"
      rounded
      size="s"
      className={cx(akinatorCompletionButton, isSelected && 'active')}
      onMouseEnter={() => onMouseEnter(elementIndex)}
      onMouseLeave={onMouseLeave}
      onClick={() => {
        onCompletionClick(completion);
        sendAkinatorCompletionAnalyticsEvent(elementIndex, completion);
      }}
    >
      <span className={akinatorCompletionButtonText}>{completion.name}</span>
    </RegularButton>
  );
};
